import React, { useState } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { primaryColor } from "../../Constants";

const MuiDatePicker = ({ label, value, onChange, disabled, maxDate, minDate }) => {
  const grayColor = "#6B7280"; // Tailwind gray-500

  const theme = createTheme({
    palette: {
      primary: {
        main: primaryColor,
      },
    },
    components: {
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            borderRadius: "6px",
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: grayColor, // default border
              borderWidth: "2px",
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: primaryColor, // focused border
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: primaryColor,
            },
          },
          input: {
            padding: "10px 12px",
            color: "#000000 !important", // black text
            fontSize: "0.850rem",
          },
        },
      },
      MuiInputLabel: {
        styleOverrides: {
          root: {
            position: "absolute",
            left: "8px",
            padding: "0 4px",
            backgroundColor: "#FFFFFF",
            fontSize: "0.850rem",
            color: grayColor,
            top: "50%",
            transform: "translateY(-50%)",
            transition: "all 0.2s ease-in-out",

            "&.MuiInputLabel-shrink": {
              top: "-12px",
              transform: "translateY(0)",
              fontSize: "0.850rem",
              color: primaryColor,
            },

            "&.Mui-focused": {
              color: primaryColor,
            },

            "&[readonly]": {
              color: "#000000 !important",
              cursor: "pointer",
            },
          },
        },
      },
    },
  });
  const [open, setOpen] = useState(false);

  return (
    <ThemeProvider theme={theme}>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <DatePicker
          label={label}
          value={value}
          onChange={(date) => {
            if (date) {
              onChange(date); // Updates selected date
              setOpen(false); // Closes picker after selection
            }
          }}
          disabled={disabled}
          maxDate={maxDate || null}
          minDate={minDate || null}
          open={open}
          onClose={() => setOpen(false)} // ✅ Closes on outside click
          onOpen={() => setOpen(true)} // ✅ Opens when input is clicked
          slotProps={{
            textField: {
              fullWidth: true,
              inputProps: { readOnly: true }, // ⛔ Prevents manual input
              onClick: () => setOpen(true), // 📅 Opens picker when clicking input
              sx: {
                "& .MuiOutlinedInput-root": {
                  minHeight: "40px",
                  display: "flex",
                  alignItems: "center",
                  // borderColor: primaryColor, // remove if you want default gray border
                  backgroundColor: "#FFFFFF",
                },
                "& .MuiInputBase-input": {
                  fontSize: "1rem",
                  fontWeight: 300,
                  color: "#000000 !important",
                  backgroundColor: "#FFFFFF",
                  padding: "8px 12px",
                  height: "1.5rem",
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                  "&.Mui-disabled": {
                    color: "#000000 !important",
                  },
                  "&[readonly]": {
                    color: "#000000 !important",
                  },
                },
                "& input": {
                  color: "#000000 !important",
                  fontSize: "1rem",
                },
              },
            },
            popper: { sx: { zIndex: 1300 } },
          }}
        />
      </LocalizationProvider>
    </ThemeProvider>
  );
};

export default MuiDatePicker;
